import React from 'react';

import cn from 'classnames';
import { isEmpty, omit } from 'lodash';
import PropTypes from 'prop-types';
import { HiChevronDown } from 'react-icons/hi';

import EmptyState from 'modules/common/components/EmptyState';
import { FormInputCheckBox } from 'modules/common/input';
import { Text } from 'modules/common';

// TODO: Note: This component can handle 2 level or category, if 3 level is need refactor this
function CategoryList({ data, value, onGetValue, level, withGroups, isInput }) {
  const [form, setForm] = React.useState([]);

  const [active, setActive] = React.useState(
    value.length > 0 ? value?.map((x) => x?.[`level${level[0]}`]?.value) : []
  );

  const handleToSetActive = (key) => (e) => {
    e.preventDefault();
    const isActive = active?.indexOf(key) > -1;

    setActive((prev) =>
      isActive ? prev?.filter((x) => x !== key) : [...prev, key]
    );
  };

  // sample

  const handleOnCheck = (index, item) => () => {
    const isActive =
      form[index]?.[`level${level[1]}`]?.findIndex(
        (i) => i?.value === item?.value
      ) > -1;
    const args = form?.map((c, i) => {
      if (i === index) {
        return {
          ...c,
          [`level${level[1]}`]: isActive
            ? c?.[`level${level[1]}`]?.filter((x) => x?.value !== item?.value)
            : [...c?.[`level${level[1]}`], item],
        };
      }
      return c;
    });

    let v = value;

    args?.map((subItem) => {
      v = v?.filter(
        (x) =>
          x?.[`level${level[0]}`]?.value !==
          subItem?.[`level${level[0]}`]?.value
      );

      return subItem;
    });

    const $v = [...v, ...args];

    onGetValue($v?.filter((x) => !isEmpty(x?.[`level${level[1]}`])));
    setForm($v);
  };

  React.useEffect(() => {
    setForm(
      data?.map((item) => {
        const index = value?.findIndex(
          (x) => x?.[`level${level[0]}`]?.value === item?.value
        );
        return {
          [`level${level[0]}`]: omit(item, ['child']),
          [`level${level[1]}`]:
            index > -1 ? value[index]?.[`level${level[1]}`] : [],
        };
      })
    );
  }, [data, level, value]);

  return (
    <div className="h-full divide-y divide-gray-200">
      {data?.length > 0 ? (
        data?.map((item, i) => {
          const { child = [] } = item;
          const isActive = active?.indexOf(item?.value) > -1;

          return (
            <div key={item?.value}>
              <div
                className={cn('py-3', {
                  'px-3': isInput,
                })}
              >
                <div
                  className={cn('flex items-center cursor-pointer', {
                    'pb-3': isActive,
                  })}
                  role="presentation"
                  onClick={handleToSetActive(item?.value)}
                >
                  <Text weight="bold">{item?.label}</Text>

                  <span className="ml-auto">
                    <HiChevronDown
                      className={cn(
                        'h-5 w-5 ease-out-in transition transform mr-1',
                        {
                          'rotate-0 duration-500': isActive,
                          '-rotate-90 duration-700': !isActive,
                        }
                      )}
                    />
                  </span>
                </div>

                <div
                  className={cn(
                    'transition transform ease-out-in ml-1 space-y-1',
                    {
                      'h-auto duration-300 opacity-300 opacity-100': isActive,
                      'h-0 overflow-hidden duration-200 opacity-0 ': !isActive,
                    }
                  )}
                >
                  {child?.map((c) =>
                    withGroups && c?.child?.length > 0 ? (
                      <div key={c?.value}>
                        <Text>{c.label}</Text>

                        {c?.child?.map((groupItem) => (
                          <div
                            key={groupItem?.value}
                            className="py-0.5 last:pb-0 pl-4 space-y-1"
                          >
                            <FormInputCheckBox
                              name={`level${level[1]}`}
                              onChange={handleOnCheck(i, groupItem)}
                              checked={
                                form[i]?.[`level${level[1]}`]?.findIndex(
                                  (x) => x?.value === groupItem?.value
                                ) > -1
                              }
                              label={<Text>{groupItem?.label}</Text>}
                              className="h-4 w-4"
                              labelClassName="py-1"
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div key={c?.value}>
                        <FormInputCheckBox
                          name={`level${level[1]}`}
                          onChange={handleOnCheck(i, c)}
                          checked={
                            form[i]?.[`level${level[1]}`]?.findIndex(
                              (x) => x?.value === c?.value
                            ) > -1
                          }
                          label={<Text>{c?.label}</Text>}
                          className="h-4 w-4"
                          labelClassName="py-1"
                        />
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <EmptyState />
      )}
    </div>
  );
}

CategoryList.defaultProps = {
  data: [],
  withGroups: false,
  isInput: false,
};

CategoryList.propTypes = {
  data: PropTypes.instanceOf(Array),
  onGetValue: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.instanceOf(Array).isRequired,
  level: PropTypes.instanceOf(Array).isRequired,
  withGroups: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  isInput: PropTypes.bool,
};

export default CategoryList;
